import React from 'react';
import Input from './input';
import Select from './select';
import TextArea from './textArea';

const TabContent = ({ title, inputs }) => {
  
  return (
    <div className="w-full">
      <h3 className="text-gray-800 dark:text-white text-xl font-semibold mb-10">
        {title}
      </h3>
      <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-6">
        {inputs.map((input, i) => (
          <div
            key={i}
            className={`w-full ${input.colSpan === 2 ? 'lg:col-span-2 col-span-1' : 'col-span-1'}`}
          >
            {input.element === 'input' && (
              <Input
                type={input?.type}
                label={input?.label}
                name={input?.name}
                value={input?.value}
                placeholder={input?.placeholder}
                onError={input?.onError}
                onChange={input?.onChange}
                onBlur={input?.onBlur}
                disabled={input?.disabled}
              />
            )}

            {input.element === 'select' && (
              <Select
                label={input?.label}
                type={input?.type}
                name={input?.name}
                value={input?.value}
                options={input?.options}
                placeholder={input?.placeholder}
                onError={input?.onError}
                onChange={input?.onChange}
                onBlur={input?.onBlur}
                disabled={input?.disabled}
              />
            )}

            {input.element === 'textarea' && (
              <TextArea
                label={input?.label}
                type={input?.type}
                name={input?.name}
                value={input?.value}
                placeholder={input?.placeholder}
                onError={input?.onError}
                onChange={input?.onChange}
                onBlur={input?.onBlur}
                disabled={input?.disabled}
              />
            )}

            {input.element === 'choice' && (
              <div className="w-full">
                <label className="text-sm mb-2 block dark:text-white">{input.label}</label>
                <div className="w-fit flex gap-2">
                  {input.choices.map((choice, index) => (
                    <button
                      key={index}
                      type="button"
                      value={choice.value}
                      disabled={input?.disabled}
                      className={`px-6 py-3 text-xs border-[1.5px] border-primaryBlue rounded-sm text-primaryBlue cursor-pointer text-center hover:bg-primaryBlue hover:text-white ${
                        input.value === choice.value
                          ? 'bg-primaryBlue text-white'
                          : ''
                      }`}
                      onClick={() => input.onChange(choice.value)} 
                    >
                      {choice.label}
                    </button>
                  ))}
                </div>
                {input.onError && (
                  <p className="text-red-500 text-sm mt-1">
                    {input.onError}
                  </p>
                )}
              </div>
            )}

            {input.element === 'checkbox' && input.type === "single" && (
              <div className="w-full">
                <label className="text-sm mb-2 block dark:text-white">{input.label}</label>
                <div className="flex items-center gap-2">
                  <input
                    type="checkbox"
                    name={input.name}
                    checked={input.value} 
                    onChange={input.onChange}
                    onBlur={input.onBlur}
                    disabled={input?.disabled}
                    className="h-4 w-4 text-primaryBlue border-gray-300 rounded focus:ring-primaryBlue dark:bg-slate-800 dark:border-gray-600"
                  />
                  <span className="text-sm text-gray-800 dark:text-gray-200">{input.label}</span>
                </div>
                {input.onError && (
                  <p className="text-red-500 text-sm mt-1">
                    {input.onError}
                  </p>
                )}
              </div>
            )}

            {input.element === 'checkbox' && input.type !== "single" && (
              <div className="w-full">
                <label className="text-sm mb-2 block dark:text-white">{input.label}</label>
                <div className="flex flex-col gap-3">
                  {input.options.map((option, index) => (
                    <label key={index} className="flex items-center gap-2">
                      <input
                        type="checkbox"
                        value={option.value}
                        checked={input.value}
                        onChange={input.onChange}
                        onBlur={input.onBlur}
                        disabled={input?.disabled}
                        className="h-4 w-4 text-primaryBlue border-gray-300 rounded focus:ring-primaryBlue dark:bg-slate-800 dark:border-gray-600"
                      />
                      <span className="text-sm text-gray-800 dark:text-gray-200">{option.label}</span>
                    </label>
                  ))}
                </div>
                {input.onError && (
                  <p className="text-red-500 text-sm mt-1">
                    {input.onError}
                  </p>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TabContent